<template>
  <form
    :data-vv-scope="scope"
    action="">
    <div
      v-for="(row, i) in rows"
      :key="i"
      class="c-cbr-ManualForm-row">

      <cbr-form-field
        v-validate="getValidationPerField(field.id,field.validate)"
        v-for="field in row"
        :key="field.id"
        :id="field.id"
        :label="field.label"
        :type="field.type"
        :validate="field.validate"
        :help="getToolTip(field.help)"
        :autofill="field.autofill"
        :scope="scope"
        :classes="field.classes"
        :ref="field.ref"
        v-model="data[field.id]"
        :options="field.options"
        :options_array="field.options_array"
        :data-vv-scope="scope"
        :data-vv-name="field.id"
        :has-error="showErrors && errors.has(`${scope}.${field.id}`)"
        :error-message="errors.first(`${scope}.${field.id}`)"
        @blur="val => update()"/>
    </div>

  </form>
</template>

<script>
  import CbrFormField from './CbrFormField.vue';

  export default {
    inject: ['$validator'],
    components: {
      CbrFormField
    },

    props: {
      scope: {
        type: String,
        required: true
      },
      data: {
        type: Object,
        required: true
      },
      rows: {
        type: Array,
        required: true
      },
      showErrors: {
        type: Boolean,
        default: true
      }
    },

    methods: {
      update() {
        this.$validator.validateAll(this.scope).then((result) => {
          this.$emit('valid', result);
        });
      },

      /**
      * Tool tip overridden for Spain, Portugal and France. help variable comes from CbrManualForm.
      * email_help_required is key present in the i18next.json.
      * i18next.json is responsible for internationalization.
      */
      getToolTip(help) {
       if(help && help === 'form.email_help') {

          // HACK ISRS-6817
          if (this.$router.currentRoute.params.portalUuid == "georgjensendamask") {
            return 'form.email_help_required';
          }

          if(['ES', 'PT', 'IT', 'HU', 'PL'].includes(this.data.country)) {
            return 'form.email_help_required';
          } else if(['SE', 'FR'].includes(this.data.country)) {
            return 'form.email_help_required_FR_SE';
          } else {
            return help;
          }
       }
      },

      /**
      * HACK: return_reason_others is an existing field present in CbrManualForm.
      * This method checks if the email id is not present for the country code ES,PT and FR,
      * if yes then mark Email Id field in UI as required and do corresponding validation
      * else forward the existing validations for the fields
      */
      getValidationPerField(fieldId, validate) {

        // HACK ISRS-6817
        if (fieldId == "email") {
          if (this.$router.currentRoute.params.portalUuid == "georgjensendamask") {
            return "required";
          }
        }

        if(fieldId != 'return_reason_others' && ['ES','PT','FR','IT','HU','SE','PL'].includes(this.data.country) && ( !this.data.email )) {
          return 'required';
        } else {
          return validate;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/ObjForm.vue